export default __webpack_public_path__ + "static/media/mc_cv_5.f38eec6a.jpg";